import React, { useState, useEffect } from 'react';
import style from './common.module.scss';
import classNames from 'classnames';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, ConfigProvider, Space, Tooltip } from 'antd';
import Collapse from '../collapse/collapse.jsx';
import { popularDiet } from '@/modules/plant-based/api/request';
import { painPointGetDetail, painPointGetList,getFilterMenu } from '@/modules/pain-points/api/request';
import EventBus from '@/modules/pain-points/hooks/eventBus';

const getPercent = (number,total) => {
  return (Math.round(number/total*10000)/100.0).toFixed(1);
}

const LeftFilterNavigateCollapsible = ({ toggleCallback }) => {
  const [selectedFilter, setSelectedFilter] = useState({
    market: 'Germany',
    dishType: 'Pasta',
    subType: '',
    needStates: '',
    generation: '',
    lifeStage: '',
    frequencyOfConsumption: '',
    contemporaryCooks: '',
    themes: '',
  });

  useEffect(() => {
    EventBus.addEventListener('sendFilterData', sendFilterData);
    EventBus.addEventListener('resetFilterData', resetFilterData);
    return () => {
      EventBus.removeEventListener('sendFilterData', sendFilterData);
      EventBus.removeEventListener('resetFilterData', resetFilterData);
    };
  }, []);

  const sendFilterData = (filterData) => {
    setSelectedFilter(filterData.detail);
    applyOnClick();
  }
  
  const handleFilterChange = (filterData) => {
    setSelectedFilter(filterData);
  };

  const handleClearAll = () => {
    // selectedFilter = {
    //   market: 'Germany',
    //   dishType: 'Pasta',
    //   subType: '',
    //   needStates: '',
    //   generation: '',
    //   lifeStage: '',
    //   frequencyOfConsumption: '',
    //   contemporaryCooks: '',
    //   themes: '',
    // };
    
    EventBus.dispatchEvent('resetAllFilters', true);
    
    // applyOnClick();
  };
  const resetFilterData = (filterData) => {
    setSelectedFilter(prevState => {
      const newState = filterData.detail;
      applyReset(newState); // 直接传入新状态
      return newState;
    });
  }

  const applyReset = async(newFilterData) => {
    try {
      // 显示加载遮罩
      EventBus.dispatchEvent('setLoadingEvent', true);
      
      let filterData = {}
      for (let item in newFilterData) {
        switch(newFilterData[item]){
          case 'Easy everyday cooking':
            filterData[item] = ['D2.a.1'];
            break;
          case 'An enjoyment meal':
            filterData[item] = ['D2.a.2'];
            break;
          // case 'No':
          //   filterData[item] = ['No, but Id be open to it '];
          //   break;
          default:
            filterData[item] = newFilterData[item]!='' && newFilterData[item]!=undefined ? [newFilterData[item]] : [];
            break;
        }
        // filterData[item] = selectedFilter[item]!='' ? [selectedFilter[item]] : [];
      }
      const result = await painPointGetList(filterData);
      EventBus.dispatchEvent('filterChangeEvent', filterData);
      let list = [] 
      result.data.map(item => {
        if(item.importance == 0 && item.willingness_to_pay == 0 && item.reach == 0){
          return;
        }
        let x = getPercent(item.importance['response'],item.importance['count']);
        let y = getPercent(item.willingness_to_pay['response'],item.willingness_to_pay['count']);
        let z = getPercent(item.reach,item.importance['count']);
        let name = item.need_statement;
        list.push([x, y, z, name, item.needStatementId]);
      });

      EventBus.dispatchEvent('painPointListEvent', list);
      EventBus.dispatchEvent('painPointVerbatimsEvent', {detail: []});
      console.log('--------列表数据---------', result.data);
    } catch (error) {
      console.error('Filter error:', error);
    } finally {
      // 无论成功失败都需要关闭加载遮罩
      EventBus.dispatchEvent('setLoadingEvent', false);
    }
  }

  const applyOnClick = async () => {
    try {
      // 显示加载遮罩
      EventBus.dispatchEvent('setLoadingEvent', true);
      
      let filterData = {}
      for (let item in selectedFilter) {
        switch(selectedFilter[item]){
          case 'Easy everyday cooking':
            filterData[item] = ['D2.a.1'];
            break;
          case 'An enjoyment meal':
            filterData[item] = ['D2.a.2'];
            break;
          // case 'No':
          //   filterData[item] = ['No, but Id be open to it '];
          //   break;
          default:
            filterData[item] = selectedFilter[item]!='' && selectedFilter[item]!=undefined ? [selectedFilter[item]] : [];
            break;
        }
        // filterData[item] = selectedFilter[item]!='' ? [selectedFilter[item]] : [];
      }
      const result = await painPointGetList(filterData);
      EventBus.dispatchEvent('filterChangeEvent', filterData);
      let list = [] 
      result.data.map(item => {
        if(item.importance == 0 && item.willingness_to_pay == 0 && item.reach == 0){
          return;
        }
        let x = getPercent(item.importance['response'],item.importance['count']);
        let y = getPercent(item.willingness_to_pay['response'],item.willingness_to_pay['count']);
        let z = getPercent(item.reach,item.importance['count']);
        let name = item.need_statement;
        list.push([x, y, z, name, item.needStatementId]);
      });

      EventBus.dispatchEvent('painPointListEvent', list);
      EventBus.dispatchEvent('painPointVerbatimsEvent', {detail: []});
      console.log('--------列表数据---------', result.data);
    } catch (error) {
      console.error('Filter error:', error);
    } finally {
      // 无论成功失败都需要关闭加载遮罩
      EventBus.dispatchEvent('setLoadingEvent', false);
    }
  };


  return (
    <div className={style.filterBox}>
      <div className={style.filterHeader}>
        <div className={classNames(style.left15, style.flexBetween)}>
          <span className={style.textTitle}>Filter</span>
          <div style={{margin:'auto 0'}}>
            <Tooltip title="Clear" onClick={handleClearAll}>
              <Button type="link" style={{ color: 'rgba(255,255,255,0.6)' }} icon={<ClearOutlined />} />
            </Tooltip>
            <Button onClick={applyOnClick} type="text" size="small" shape="round"
                    style={{ background: '#1a3d1b', color: '#FFF' ,fontSize: '0.8vw',height: '1.5vw'}}>Apply</Button>
          </div>
        </div>
      </div>
      <div className={style.filterContent}>
        <div style={{ marginTop: '20px' }} />
        <Collapse onFilterChange={handleFilterChange} />
        <div style={{ marginBottom: '50px' }} />
      </div>
    </div>
  );
};

export default LeftFilterNavigateCollapsible;
